/* Material */
export const GET_CATEGORIES= "GET_CATEGORIES"
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS"
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL"

export const POST_CATEGORY= "POST_CATEGORY"
export const POST_CATEGORY_SUCCESS = "POST_CATEGORY_SUCCESS"
export const POST_CATEGORY_FAIL = "POST_CATEGORY_FAIL"